import commonUtil from "../../util/common-utils";
import { UISymbols } from "../../constants/ui-symbols";

export interface ProductRatingSummaryArgs {
    averageRating?: unknown;
    reviewCount?: unknown;
    averageRole?: string;
    reviewCountRole?: string;
    includeDataRoles?: boolean;
}

export function renderProductRatingStatsHtml(args: ProductRatingSummaryArgs = {}): string {
    const starFilled = UISymbols.STAR_FILLED;
    const includeDataRoles = Boolean(args.includeDataRoles);

    const reviewCountRaw = Number(args.reviewCount ?? 0);
    const reviewCount = Number.isFinite(reviewCountRaw) && reviewCountRaw > 0 ? Math.floor(reviewCountRaw) : 0;

    const averageRaw = args.averageRating;
    const averageNum = averageRaw === null || averageRaw === undefined ? null : Number(averageRaw);
    const averageText = commonUtil.formatAverageRating(averageNum, 2, "--");

    const numberFormat = new Intl.NumberFormat();

    const averageRoleAttr = includeDataRoles && args.averageRole ? ` data-role="${args.averageRole}"` : "";
    const reviewCountRoleAttr = includeDataRoles && args.reviewCountRole ? ` data-role="${args.reviewCountRole}"` : "";

    return `
        <div class="post-product-linker__stats" aria-label="Product rating and reviews">
            <span class="post-product-linker__stat post-product-linker__stat--rating" title="Rating">
                <span class="post-product-linker__star-char" aria-hidden="true">${starFilled}</span>
                <span class="rating-average"${averageRoleAttr}>${averageText}</span>
            </span>
            <span class="post-product-linker__stat post-product-linker__stat--reviews" title="Reviews">
                <span class="product-review-count"${reviewCountRoleAttr} data-count="${reviewCount}">${numberFormat.format(reviewCount)}</span>
                <span class="post-product-linker__review-label" data-translate="reviews">Reviews</span>
            </span>
        </div>
    `;
}
